import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';
import type { WorkLogResponse } from '@/generated/types/navigator/types.gen';
import type { FilterState } from '@/features/filterSlice';

export const WorklogModalMode = {
  ADD: 'add',
  EDIT: 'edit',
  BULK_ADD: 'bulk_add',
} as const;

export type WorklogModalMode =
  (typeof WorklogModalMode)[keyof typeof WorklogModalMode];

interface WorklogModalState {
  isOpened?: boolean;
  worklogData?: WorkLogResponse;
  mode?: WorklogModalMode;
  spanId?: string;
  filter?: FilterState;
  spanCount?: number;
}

const initialState: WorklogModalState = {
  isOpened: false,
  worklogData: undefined,
  mode: WorklogModalMode.ADD,
  spanId: '',
};

const worklogModalSlice = createSlice({
  name: 'worklogModal',
  initialState,
  reducers: {
    openWorklogModal: (state, action: PayloadAction<WorklogModalState>) => {
      Object.assign(state, action.payload, { isOpened: true });
    },
    closeWorklogModal: () => initialState,
  },
});

export const { openWorklogModal, closeWorklogModal } =
  worklogModalSlice.actions;

export default worklogModalSlice.reducer;
